import { Box, Text } from "@chakra-ui/react";
import React from "react";

function BeforeFooter() {
  return (
    <div>
      {" "}
      <hr />
      <Box
        p="25px"
        bg="#FFFFFF"
        color={"#757171"}
        borderTop="2px solid silver"
        marginTop={"20px"}
        display={{ base: "none", sm: "block", md: "block", lg: "block" }}
      >
        <Text fontSize={"14px"} pb="9px" fontWeight={"bold"} textAlign={"left"}>
          {" "}
          Top Stories:Brand Directory
        </Text>
        <Text fontSize={"12px"} pb="9px" textAlign={"left"}>
          {" "}
          MOST SEARCHED FOR ON FLIPKART:Flipkart Axis Bank Super Elite Credit
          cardPrimebook LaptopsBounce Infinity E1Buy Laptop on EMIInfinix Zero
          Book UltraOPPO Reno8 5GOPPO Reno8 Pro 5GFresh Flower BouquetHoli
          HampersHoli GiftsBouquetOneplus MonitorsSell Old Mobile PhonesPremium
          LaptopsElectronics StorePhone coverVivo Y33TInfinix Y1 PlusOkaya
          Electric Vehiclesbgauss electric scooterOPPO Reno7 Pro 5GiPhone
          13iPhone 13 ProiPhone 13 Pro MaxiPhone 13 MiniGoogle Pixel 6a
          coversFlipkart QuickAmpere MagnusFlipkart Help CentreOnline Boat
          StoreCovers from Rs 99Flipkart Track OrdersFlipkart Manage
          OrdersFlipkart Return OrdersFlipkart Gift Cards StoreFlipkart Axis
          Bank Credit CardFlipkart Pay Later MOBILES:iPhone 12 64GBiPhone 12 Pro
          512GBiPhone 12 128GBVivo Y91iVivo Y11Vivo Y15Vivo Y50Vivo Y12Reno2
          FOppo A12Oppo F15Oppo A31Samsung A71Samsung A51Samsung A31Realme
          X2iPhone 11iPhone 11 ProMobile CoverMobile Offersiphone x4G
          MobileNokia MobileSamsung MobileiphoneOppo MobileVivo Mobile
          CAMERA:GoPro Action CameraNikon CameraCanon CameraSony CameraCanon
          DSLRNikon DSLR LAPTOPS:MacBook Pro M2Premium Laptopacer Ryzen 3 Dual
          Core 3250U - (8 GB/256 GB SSD/Windows 11 Home) Z2-493 Thin and Light
          LaptopASUS Vivobook S14 OLED (2022)ASUS Zenbook 14 OLED (2022)Realme
          Book Prime Core i5 11th GenMicrosoft Surface Go Pentium 128GBBranded
          LaptopsApple LaptopsAcer LaptopsLenovo LaptopsDell LaptopsAsus
          LaptopsHP LaptopsGaming Laptops2 in 1 LaptopsLaptopsDell latest
          laptops 2022HP latest laptops 2022Infinix INBook X1 Neo Series Celeron
          Quad Core - (8 GB/256 GB SSD/Windows 11 Home) XL22 Thin and Light
          LaptopMicrosoft Laptops12th Gen Intel Core Laptops TVS:Nokia
          TVPanasonic TVThomson TVVu TVRealme TVMotorola TVOnePlus TVsLG
          TVTVSony TVSamsung TVAndroid TelevisionIffalcon TvMi TV LARGE
          APPLIANCES:TV & Appliances End of Season SaleTelevisionWashing
          MachinesRefrigeratorsAir ConditionersElectric CookersElectric
          Jug(Heater) / Travel KettlesInduction CooktopsInverters /
          stabilizerIrons / Iron BoxMixer Grinder JuicerWet
          GrindersChimneysMicrowave OvensVacuum CleanersWater PurifierFanMarQ
          Customer Care CLOTHING:Men ShirtsKurta PajamaKurtasMen
          T-ShirtsJeansSareeDressesKids DressesDesigner Salwar SuitsBraDesigner
          KurtisTrack PantMen KurtasGym WearParty DressesPalazzo SuitsBoys
          ClothingGlovesNightyMaxi DressesAnarkaliGownsCulottesSalwar
          SuitsKurtisDesigner SareesLeggingsShortsGeorgette SareesEthnic
          WearBriefs & TrunksNike WatchesAscot TieCorset Tops TunicsLeather PU
          SkirtsCorset tops camisolesWomen magenta earringsNo collar
          jacketsGreen dress materialBlack patiala kurta setMen camel shoes
          casualBlack pathaniTassel SareesKhaki dressesKids formal dressesMauve
          shirtsWomen henleyuppada pattu sareesLeopard dressesSleeveless shrugs
          FOOTWEAR:ShoesAdidas ShoesReebok ShoesNike ShoesPuma ShoesBootsBata
          ShoesWoodland ShoesSkechers ShoesSneakersWomens BootsSports
          ShoesLoafersSandalsLotto Sports ShoesCasual ShoesWomens Skechers
          ShoesAsics Sports ShoesFormal ShoesSchool Shoes GROCERIES:PhonePe
          Grocery VoucherHand WashSoapCashew NutsSunflower OilEggsToilet
          CleanerHarpic Toilet CleanerDettol SoapMustard
          OilBiscuitsCheesePatanjali AttaFortune OilAashirvaad AttaTea BEST
          SELLING ON FLIPKART:Fire-Boltt Ninja Calling Pro Bluetooth Calling
          Smartwatch 1.69 inch HD Display SmartwatchBest Gas GeyserKitchen
          GeyserNutri BlendersPortable Air CoolerBest Air CoolerBagsHitachi
          Refrigerator 3 DoorBooksToysCandlesHelmetsWall ClocksBaby
          FoodChocolatesCyclesCalculatorsLipsticksMaskVertiv UPSFastrack
          WatchesWalletsEarringsGold CoinsRealme Pad MiniHandbagsconekt SW2
          SmartwatchMivi DuoPods a350Speaker Cleaner
          FURNITURE:FurnitureSofasBedsDining setsWardrobesMattressesTV
          UnitsTablesChairsShelvesBean BagsOffice ChairsComputer TableOffice
          TablesRed SofaWakefit BedsWhite SofaWakefit MattressGreen SofaBlack
          SofaBrown Sofa BGMH:Whey ProteinHomeopathyBounce InfinityValentine
          Gift for BoyfriendValentine Gift for GirlfriendValentines Day
          GiftsChristmas GiftsCalendar 2023Online GuitarBooks StoreMusical
          Instrument StoreDabur ChyawanprashBaidyanath ChyawanprashEnergy
          DrinksToysMilk Drink MixesRakhiChyawanprashIndian FlagProtein
          Supplements
        </Text>
        <Text fontSize={"16px"} pb="9px" fontWeight={"bold"} textAlign={"left"}>
          {" "}
          Flipkart: The One-stop Shopping Destination
        </Text>
        <Text fontSize={"12px"} pb="9px" textAlign={"left"}>
          {" "}
          E-commerce is revolutionizing the way we all shop in India. Why do you
          want to hop from one store to another in search of the latest phone
          when you can find it on the Internet in a single click? Not only
          mobiles. Flipkart houses everything you can possibly imagine, from
          trending electronics like laptops, tablets, smartphones, and mobile
          accessories to in-vogue fashion staples like shoes, clothing and
          lifestyle accessories; from modern furniture like sofa sets, dining
          tables, and wardrobes to appliances that make your life easy like
          washing machines, TVs, ACs, mixer grinder juicers and other
          time-saving kitchen and small appliances; from home furnishings like
          cushion covers, mattresses and bedsheets to toys and musical
          instruments, we got them all covered. You name it, and you can stay
          assured about finding them all here. For those of you with erratic
          working hours, Flipkart is your best bet. Shop in your PJs, at night
          or in the wee hours of the morning. This e-commerce never shuts down.
        </Text>
        <Text fontSize={"12px"} pb="9px" textAlign={"left"}>
          {" "}
          What's more, with our year-round shopping festivals and events, our
          prices are irresistible. We're sure you'll find yourself picking up
          more than what you had in mind. If you are wondering why you should
          shop from Flipkart when there are multiple options available to you,
          well, the below will answer your question.
        </Text>
        <Text fontSize={"16px"} pb="9px" fontWeight={"bold"} textAlign={"left"}>
          Flipkart Plus
        </Text>
        <Text fontSize={"12px"} pb="9px" textAlign={"left"}>
          A world of limitless possibilities awaits you - Flipkart Plus was
          kickstarted as a loyalty reward programme for all its regular
          customers at zero subscription fee. All you need is 500 supercoins to
          be a part of this service. For every 100 rupees spent on Flipkart
          order, Plus members earns 4 supercoins & non-plus members earn 2
          supercoins. Free delivery, early access during sales and shopping
          festivals, exchange offers and priority customer service are the top
          benefits to a Flipkart Plus member. In short, earn more when you shop
          more!
        </Text>
        <Text fontSize={"12px"} pb="9px" textAlign={"left"}>
          What's more, you can even use the Flipkart supercoins for a number of
          exciting services, like: An annual Zomato Gold membership An annual
          Hotstar Premium membership 6 months Gaana plus subscription Rupees 550
          instant discount on flights on ixigo Check out
          https://www.flipkart.com/plus/all-offers for the entire list. Terms
          and conditions apply.
        </Text>
        <Text fontSize={"16px"} pb="9px" fontWeight={"bold"} textAlign={"left"}>
          No Cost EMI
        </Text>
        <Text fontSize={"12px"} pb="9px" textAlign={"left"}>
          In an attempt to make high-end products accessible to all, our No Cost
          EMI plan enables you to shop with us under EMI, without shelling out
          any processing fee. Applicable on select mobiles, laptops, large and
          small appliances, furniture, electronics and watches, you can now shop
          without burning a hole in your pocket. If you've been eyeing a product
          for a long time, chances are it may be up for a no cost EMI. Take a
          look ASAP! Terms and conditions apply.
        </Text>
        <Text fontSize={"16px"} pb="9px" fontWeight={"bold"} textAlign={"left"}>
          EMI on Debit Cards
        </Text>
        <Text fontSize={"12px"} pb="9px" textAlign={"left"}>
          Did you know debit card holders account for 79.38 crore in the
          country, while there are only 3.14 crore credit card holders? After
          enabling EMI on Credit Cards, in another attempt to make online
          shopping accessible to everyone, Flipkart introduces EMI on Debit
          Cards, empowering you to shop confidently with us without having to
          worry about pauses in monthly cash flow. At present, we have partnered
          with Axis Bank, HDFC Bank, State Bank of India and ICICI Bank for this
          facility. More power to all our shoppers! Terms and conditions apply.
        </Text>
        <Text fontSize={"16px"} pb="9px" fontWeight={"bold"} textAlign={"left"}>
          Mobile Exchange Offers
        </Text>
        <Text fontSize={"12px"} pb="9px" textAlign={"left"}>
          Get an instant discount on the phone that you have been eyeing on.
          Exchange your old mobile for a new one after the Flipkart experts
          calculate the value of your old phone, provided it is in a working
          condition without damage to the screen. If a phone is applicable for
          an exchange offer, you will see the 'Buy with Exchange' option on the
          product description of the phone. So, be smart, always opt for an
          exchange wherever possible. Terms and conditions apply.
        </Text>
        <Text fontSize={"16px"} pb="9px" fontWeight={"bold"} textAlign={"left"}>
          What Can You Buy From Flipkart?
        </Text>
        <Text fontSize={"16px"} pb="9px" fontWeight={"bold"} textAlign={"left"}>
          Mobile Phones
        </Text>
        <Text fontSize={"12px"} pb="9px" textAlign={"left"}>
          From budget phones to state-of-the-art smartphones, we have a mobile
          for everybody out there. Whether you're looking for larger, fuller
          screens, power-packed batteries, blazing-fast processors,
          beautification apps, high-tech selfie cameras or just large internal
          space, we take care of all the essentials. Shop from top brands in the
          country like Samsung, Apple, Oppo, Xiaomi, Realme, Vivo, and Honor to
          name a few. Rest assured, you're buying from only the most reliable
          names in the market. What's more, with Flipkart's Complete Mobile
          Protection Plan, you will never again find the need to run around
          service centres. This plan entails you to a number of post-purchase
          solutions, starting at as low as Rupees 99 only! Broken screens,
          liquid damage to phone, hardware and software glitches, and
          replacements - the Flipkart Complete Mobile Protection covers a
          comprehensive range of post-purchase problems, with door-to-door
          services.
        </Text>

        <Text fontSize={"16px"} pb="9px" fontWeight={"bold"} textAlign={"left"}>
          Large Appliances
        </Text>
        <Text fontSize={"12px"} pb="9px" textAlign={"left"}>
          Sleek TVs, power-saving refrigerators, rapid-cooling ACs, resourceful
          washing machines - discover everything you need to run a house under
          one roof. Our Dependable TV and Appliance Store ensures zero transit
          damage, with a replacement guarantee if anything goes wrong; delivery
          and installation as per your convenience and a double warranty
          (Official Brand Warranty along with an extended Flipkart Warranty) -
          rest assured, value for money is what is promised and delivered. Shop
          from market leaders in the country like Samsung, LG, Whirlpool, Midea,
          Mi, Vu, Panasonic, Godrej, Sony, Daikin, and Hitachi among many
          others.
        </Text>
        <Text fontSize={"16px"} pb="9px" fontWeight={"bold"} textAlign={"left"}>
          Small Home Appliances
        </Text>
        <Text fontSize={"12px"} pb="9px" textAlign={"left"}>
          Find handy and practical home appliances designed to make your life
          simpler: electric kettles, OTGs, microwave ovens, sandwich makers,
          hand blenders, coffee makers, and many more other time-saving
          appliances that are truly crafted for a quicker lifestyle. Live life
          king size with these appliances at home.
        </Text>
        <Text fontSize={"16px"} pb="9px" fontWeight={"bold"} textAlign={"left"}>
          Lifestyle
        </Text>
        <Text fontSize={"12px"} pb="9px" textAlign={"left"}>
          Flipkart, 'India ka Fashion Capital', is your one-stop fashion
          destination for anything and everything you need to look good. Our
          exhaustive range of Western and Indian wear, summer and winter
          clothing, formal and casual footwear, bridal and artificial jewellery,
          long-lasting make-up, grooming tools and accessories are sure to sweep
          you off your feet. Shop from crowd favourites like Vero Moda, Forever
          21, Only, Arrow, Woodland, Nike, Puma, Revlon, Mac, and Sephora among
          dozens of other top-of-the-ladder names. From summer staple maxi
          dresses, no-nonsense cigarette pants, traditional Bandhani kurtis to
          street-smart biker jackets, you can rely on us for a wardrobe that is
          up to date. Explore our in-house brands like Metronaut, Anmi, and
          Denizen, to name a few, for carefully curated designs that are the
          talk of the town. Get ready to be spoiled for choice.Festivals, office
          get-togethers, weddings, brunches, or nightwear - Flipkart will have
          your back each time.
        </Text>
        <Text fontSize={"16px"} pb="9px" fontWeight={"bold"} textAlign={"left"}>
          Home and Furniture
        </Text>
        <Text fontSize={"12px"} pb="9px" textAlign={"left"}>
          Moving to a new place is never easy, especially if you're buying new
          furniture. Beds, sofa sets, dining tables, wardrobes, and TV units -
          it's not easy to set up everything again. With the hundreds of options
          thrown at you, the ride could be overwhelming. What place is reliable,
          what furniture will stand the test of time? These are questions you
          must ask before you choose a store. Well, our Durability Certified
          Furniture Store has not only curated a range of furniture keeping in
          mind the modern Indian consumer but furniture that comes with a lab
          certification, ensuring they last you for up to 10 years. Yes, all our
          furniture has gone through 35 stability and load tests so that you
          receive only the best-quality furniture. Be FurniSure, always. Names
          to look out for are Nilkamal, Godrej Interio, Urban Ladder, HomeTown,
          Durian and Perfect Homes.
        </Text>
        <Text fontSize={"12px"} pb="9px" textAlign={"left"}>
          You may have your furniture all set up, but they could end up looking
          flat and incomplete without complementary decor. Curtains, cushion
          covers, bed sheets, wall shelves, paintings, floor lamps - find
          everything that turns a house to an inviting home under one roof at
          Flipkart.
        </Text>
        <Text fontSize={"16px"} pb="9px" fontWeight={"bold"} textAlign={"left"}>
          Baby and Kids
        </Text>
        <Text fontSize={"12px"} pb="9px" textAlign={"left"}>
          Your kids deserve only the best. From bodysuits, booties, diapers to
          strollers, if you're an expecting mother or a new mother, you will
          find everything you need to set sail on a smooth parenting journey
          with the help of our baby care collection. When it comes to safety,
          hygiene and comfort, you can rely on us without a second thought.
          Huggies, Pampers, MamyPoko, and Johnson & Johnson: we host only the
          most-trusted names in the business for your baby.
        </Text>
        <Text fontSize={"16px"} pb="9px" fontWeight={"bold"} textAlign={"left"}>
          Books, Sports and Games
        </Text>
        <Text fontSize={"12px"} pb="9px" textAlign={"left"}>
          Work hard and no play? We don't believe in that. Get access to
          best-selling fiction and non-fiction books by your favourite authors,
          thrilling English and Indian blockbusters, most-wanted gaming
          consoles, and a tempting range of fitness and sports gadgets and
          equipment bound to inspire you to get moving.
        </Text>
        <Text fontSize={"16px"} pb="9px" fontWeight={"bold"} textAlign={"left"}>
          Grocery/Supermart
        </Text>
        <Text fontSize={"12px"} pb="9px" textAlign={"left"}>
          Launching into the grocery vertical, Flipkart introduces Supermart
          that is out to bring everyday essentials close to you. From pulses,
          spices, dairy, personal and sanitary care, breakfast essentials,
          health drinks, spreads, ready to cook, grooming to cleaning agents, we
          are happy to present everything you need to run a house. Now buy
          Grocery products for as low as 1 Rupee only - our 1 Rupee Store
          presents new products every day for a nominal price of 1 Rupee only.
          Terms and conditions apply.
        </Text>
      </Box>
    </div>
  );
}

export default BeforeFooter;
